import * as React from "react";
import { createBrowserRouter, Navigate, Outlet } from "react-router-dom";
import UpdateLiveLocation from "../class/components/address/components/UpdateLiveLocation";
import FcmForegroundNotifier from "../class/components/notifications/FcmForegroundNotifier";
import PushPermissionModal from "../class/components/notifications/PushPermissionModal";
import AuthLayout from "../class/components/layout/AuthLayout";
import Layout from "../class/components/layout/Layout";
import { PrivateRoute, RoleRestrict } from "../config/Security";
import Register from "../class/pages/auth/Register";
import UsersPage from "../class/pages/manage/users/UsersPage";
import MakeUserPage from "../class/pages/manage/users/MakeUserPage";
import FileManagerPage from "../class/pages/fileManager/FileManagerPage";
import AccountDetailsPage from "../class/pages/account/AccountDetailsPage";
import WalletsPage from "../class/pages/manage/wallets/WalletsPage";
import WalletHistoryPage from "../class/pages/manage/wallets/WalletHistoryPage";
import WalletPage from "../class/pages/wallet/WalletPage";
import WalletParamPayPage from "../class/pages/wallet/WalletParamPayPage";
import LoginWithToken from "../class/pages/auth-new/LoginWithToken";
import SubmitUserInfo from "../class/pages/auth-new/SubmitUserInfo";
import LoginWithEmail from "../class/pages/auth-new/LoginWithEmail";
import ShopsPage from "../class/pages/manage/shops/ShopsPage";
import MakeShopPage from "../class/pages/manage/shops/MakeShopPage";
import MyShopDetails from "../class/pages/supplier/shop/MyShopDetails";
import CategoriesPage from "../class/pages/manage/categories/CategoriesPage";
import ProductsPage from "../class/pages/supplier/products/ProductsPage";
import MakeProductPage from "../class/pages/supplier/products/MakeProductPage";
import ChangeSettingsPage from "../class/pages/manage/setting/ChangeSettingsPage";
import NotificationManagerPageWrapper from "../class/pages/manage/setting/NotificationManagerPageWrapper";
import BannersPage from "../class/pages/manage/setting/banners/BannersPage";
import MainPage from "../class/pages/front/main/MainPage";
import VendorPage from "../class/pages/front/shops/VendorPage";
import FavoritesPage from "../class/pages/account/FavoritesPage";
import ContactPage from "../class/pages/front/pages/ContactPage";
import PagesPage from "../class/pages/manage/pages/PagesPage";
import MakePagePage from "../class/pages/manage/pages/MakePagePage";
import ShowPage from "../class/pages/front/pages/ShowPage";
import HomePage from "../class/pages/front/main/HomePage";
import ErrorPage from "../class/pages/errors/ErrorPage";
import CharitiesPage from "../class/pages/front/main/CharitiesPage";
import SearchPage from "../class/pages/front/main/SearchPage";
import DiscoverPage from "../class/pages/front/main/DiscoverPage";
import DiscountCodesPage from "../class/pages/manage/discounts/DiscountCodesPage";
import PaymentResultPage from "../class/pages/front/payment/PaymentResultPage";
import CheckoutPage from "../class/pages/orders/checkout/CheckoutPage";
import OrdersPage from "../class/pages/orders/OrdersPage";
import SingleOrderPage from "../class/pages/orders/SingleOrderPage";
import CouriersPage from "../class/pages/manage/couriers/CouriersPage";
import MakeCouriersPage from "../class/pages/manage/couriers/MakeCouriersPage";
import CommentsPage from "../class/pages/manage/comments/CommentsPage";
import ManageCharitiesPage from "../class/pages/manage/charities/ManageCharitiesPage";
import Dashboards from "../class/pages/dashboard/Dashboards";
import ResetPassword from "../class/pages/auth-new/ResetPassword";
import TicketsPage from "../class/pages/tickets/TicketsPage";
import BulkEditProductsPage from "../class/pages/supplier/products/BulkEditProductsPage";
import AppPage from "../class/pages/front/main/AppPage";
import BulkTicketsPage from "../class/pages/tickets/BulkTicketsPage";
import DesktopRouteGuard from "../class/components/layout/DesktopRouteGuard";
import PazarlamaPage from "../class/pages/marketing/PazarlamaPage";
import MarketingRepsPage from "../class/pages/manage/marketing/MarketingRepsPage";
import VendorLeadsPage from "../class/pages/manage/marketing/VendorLeadsPage";
import IyzipayApprovalsPage from "../class/pages/manage/iyzipay/IyzipayApprovalsPage";
import VendorSettlementsPage from "../class/pages/manage/einvoice/VendorSettlementsPage";
import EInvoicesPage from "../class/pages/manage/einvoice/EInvoicesPage";

function AppRoot() {
  return (
    <>
      <UpdateLiveLocation />
      <FcmForegroundNotifier />
      <PushPermissionModal />
      <DesktopRouteGuard />
      <Outlet />
    </>
  );
}

export const router = createBrowserRouter([
  {
    element: <AppRoot />,
    children: [
  {
    path: "/",
    element: <Layout front />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: "",
        element: <HomePage />,
      },
      {
        path: "app",
        element: <AppPage />,
      },
      {
        path: "restaurants",
        element: <MainPage industry={"restaurants"} />,
      },
      {
        path: "restaurants/search",
        element: <SearchPage industry={"restaurants"} />,
      },
      {
        path: "restaurants/discover",
        element: <DiscoverPage industry={"restaurants"} />,
      },
      {
        path: "markets",
        element: <MainPage industry={"markets"} />,
      },
      {
        path: "markets/search",
        element: <SearchPage industry={"markets"} />,
      },
      {
        path: "markets/discover",
        element: <DiscoverPage industry={"markets"} />,
      },
      /*{
                path: "charities",
                element: <CharitiesPage/>
            },*/
      {
        path: "wishlist",
        element: <FavoritesPage />,
      },
      {
        path: "vendor/:slug",
        element: <VendorPage />,
      },
      /*{
                path: ":industry/cat/:slug",
                element: <CategoryPage />
            },*/
      {
        path: "contact",
        element: <ContactPage />,
      },
      {
        path: "p/:slug",
        element: <ShowPage />,
      },
      {
        path: "checkout",
        element: <CheckoutPage />,
      },
      {
        path: "view/transaction/:platform/:source/:code",
        element: <PaymentResultPage />,
      },
    ],
  },
  {
    path: "/account",
    element: <PrivateRoute element={<Layout />} />,
    children: [
      {
        path: "details",
        element: <AccountDetailsPage />,
      },
      {
        path: "password",
        element: <AccountDetailsPage password />,
      },
      {
        path: "wallet",
        element: <WalletPage />,
      },
      {
        path: "param-pay/:transactionId/:orderId",
        element: <WalletParamPayPage />,
      },
      {
        path: "param-pay/:transactionId",
        element: <WalletParamPayPage />,
      },
      {
        path: "iyzipay-pay/:transactionId/:orderId",
        element: <WalletParamPayPage />,
      },
      {
        path: "iyzipay-pay/:transactionId",
        element: <WalletParamPayPage />,
      },
      {
        path: "my-orders",
        element: <OrdersPage role={"user"} />,
      },
      {
        path: "support",
        element: <TicketsPage role={"user"} />,
      },
      {
        path: "view-order/:number",
        element: <SingleOrderPage role={"user"} />,
      },
      {
        path: "courier-orders",
        element: <OrdersPage role={"transport"} />,
      },
      {
        path: "delivery-order/:number",
        element: <SingleOrderPage role={"transport"} />,
      },
    ],
  },
  {
    path: "/panel",
    element: <PrivateRoute element={<Layout panel />} panel />,
    children: [
      {
        path: "",
        element: <Navigate to="/panel/dashboard" replace />,
      },
      {
        path: "dashboard",
        element: <Dashboards />,
      },
      {
        path: "manage",
        element: <RoleRestrict role="admin" />,
        children: [
          {
            path: "users",
            children: [
              {
                path: "view-all",
                element: <UsersPage />,
              },
              {
                path: "add",
                element: <MakeUserPage />,
              },
              {
                path: "edit/:id",
                element: <MakeUserPage edit />,
              },
            ],
          },
          {
            path: "orders",
            element: <OrdersPage role={"admin"} />,
          },
          {
            path: "support",
            element: <TicketsPage role={"admin"} />,
          },
          {
            path: "bulk-ticket",
            element: <BulkTicketsPage role={"admin"} />,
          },
          {
            path: "view-order/:number",
            element: <SingleOrderPage role={"admin"} />,
          },
          {
            path: "pages",
            children: [
              {
                path: "view-all",
                element: <PagesPage />,
              },
              {
                path: "add",
                element: <MakePagePage />,
              },
              {
                path: "edit/:id",
                element: <MakePagePage edit />,
              },
            ],
          },
          {
            path: "shops",
            children: [
              {
                path: "view-all",
                element: <ShopsPage />,
              },
              {
                path: "add",
                element: <MakeShopPage create />,
              },
              {
                path: "edit/:id",
                element: <MakeShopPage edit />,
              },
            ],
          },
          {
            path: "categories", // Base path
            children: [
              {
                path: "view-all",
                element: <CategoriesPage />,
              },
            ],
          },
          {
            path: "discount-codes", // Base path
            children: [
              {
                path: "view-all",
                element: <DiscountCodesPage />,
              },
            ],
          },
          {
            path: "comments", // Base path
            children: [
              {
                path: "view-all",
                element: <CommentsPage />,
              },
            ],
          },
          {
            path: "charities", // Base path
            children: [
              {
                path: "view-all",
                element: <ManageCharitiesPage />,
              },
            ],
          },
          {
            path: "setting", // Base path
            children: [
              {
                path: "view-all",
                element: <ChangeSettingsPage />,
              },
              {
                path: "banners",
                element: <BannersPage />,
              },
              {
                path: "notification-manager",
                element: <NotificationManagerPageWrapper />,
              },
            ],
          },
          {
            path: "notification-manager",
            element: <Navigate to="/panel/manage/setting/notification-manager" replace />,
          },
          {
            path: "products", // Base path
            children: [
              {
                path: "view-all", // This will match "/contact"
                element: <ProductsPage />,
              },
              {
                path: "add", // This will match "/contact"
                element: <MakeProductPage create />,
              },
              {
                path: "edit/:id", // This will match "/contact"
                element: <MakeProductPage edit />,
              },
            ],
          },
          {
            path: "couriers",
            children: [
              {
                path: "view-all",
                element: <CouriersPage />,
              },
              {
                path: "edit/:id",
                element: <MakeCouriersPage edit />,
              },
            ],
          },
          {
            path: "marketing",
            children: [
              {
                path: "reps",
                element: <MarketingRepsPage />,
              },
              {
                path: "leads",
                element: <VendorLeadsPage />,
              },
            ],
          },
          {
            path: "wallets",
            children: [
              {
                path: "view-all",
                element: <WalletsPage />,
              },
              {
                path: "transactions/:id",
                element: <WalletHistoryPage />,
              },
            ],
          },
          {
            path: "iyzipay-approvals",
            element: <IyzipayApprovalsPage />,
          },
          {
            path: "vendor-settlements",
            element: <VendorSettlementsPage />,
          },
          {
            path: "einvoices",
            element: <EInvoicesPage />,
          },
        ],
      },
      {
        path: "vendor",
        element: <RoleRestrict role="supplier" />,
        children: [
          {
            path: "wallet",
            element: <WalletPage />,
          },
          {
            path: "setting/:tab",
            element: <MyShopDetails />,
          },
          {
            path: "products",
            children: [
              {
                path: "view-all",
                element: <ProductsPage />,
              },
              {
                path: "add",
                element: <MakeProductPage create />,
              },
              {
                path: "edit/:id",
                element: <MakeProductPage edit />,
              },
              {
                path: "bulk-edit",
                element: <BulkEditProductsPage />,
              },
            ],
          },
          {
            path: "orders",
            element: <OrdersPage role={"supplier"} />,
          },
          {
            path: "view-order/:number",
            element: <SingleOrderPage role={"supplier"} />,
          },
        ],
      },
      {
        path: "file-manager",
        element: <FileManagerPage />,
      },
    ],
  },

  {
    path: "/pazarlama",
    element: (
      <AuthLayout>
        <PazarlamaPage />
      </AuthLayout>
    ),
  },
  {
    path: "/login",
    element: (
      <AuthLayout>
        <LoginWithToken />
      </AuthLayout>
    ),
  },
  {
    path: "/email-login",
    element: (
      <AuthLayout>
        <LoginWithEmail />
      </AuthLayout>
    ),
  },
  {
    path: "/user-info",
    element: (
      <AuthLayout>
        <SubmitUserInfo />
      </AuthLayout>
    ),
  },
  {
    path: "/register",
    element: (
      <AuthLayout>
        <Register />
      </AuthLayout>
    ),
  },
  {
    path: "/reset-password",
    element: (
      <AuthLayout>
        <ResetPassword />
      </AuthLayout>
    ),
  },
    ],
  },
]);
